module.exports = __webpack_public_path__ + "img/home-inspections-ongoing.a2494ede.svg";